import React, { useContext, useEffect, useRef } from 'react';
import { ChalanUpdateAndReturnContext } from '../ChalanUpdateAndReturnComponent';
import { useDispatch } from 'react-redux';
import ChalanItemReturnCalc from '../Methods/ChalanItemReturnCalc';
import { useForm } from 'react-hook-form';
import { Button, Col, Form, Row } from 'react-bootstrap';
import Regex from '../../../Utilities/Regex';
import ButtonLoader from '../../CommonComponent/ButtonLoader/ButtonLoader';
import CommonStoreDropdown from '../../CommonComponent/CommonStoreDropdown/CommonStoreDropdown';
import { storeTransferAction } from '../../../Redux/Action/StoreAction';

function StoreTransferForm(props) {
  // hook
  const dispatch = useDispatch();
  const storeTransferBtnRef = useRef();
  // getting data from context
  const { singleChalanItemForReturn, singleChalanForUpdate, setNewOnClickState, chalanGetForUdpateAndReturnOnSubmit, chalanGetFieldRef } = useContext(ChalanUpdateAndReturnContext);
  // hook form property
  const {
    control,
    controlId,
    reset,
    register,
    handleSubmit,
    getValues,
    resetField,
    setValue,
    formState: { errors },
  } = useForm();

  // set default value lifecycle
  useEffect(() => {
    Object.keys(getValues()).map((fieldProps) => {
      resetField(fieldProps);
      setValue(fieldProps, '');
    });
  }, [singleChalanItemForReturn]);

  // form submit
  const onSubmit = async (data) => {
    // making payload for return
    const payload = {
      data: {
        chalan_no: singleChalanForUpdate.chalan_no,
        ...data,
        challan_item_id: singleChalanItemForReturn.id,
        store_id: getValues('store_detail')?.id || null,
      },
      reset,
      storeTransferBtnRef,
      setNewOnClickState,
      chalanGetForUdpateAndReturnOnSubmit,
      chalanGetFieldRef,
    };
    dispatch(storeTransferAction(payload));
  };
  return (
    <>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col md={4}>
            {/*Product Name with style*/}
            <Form.Group
              className="mb-2"
              controlId="formBasicEmail"
            >
              <Form.Label>Product name</Form.Label>
              <Form.Control
                defaultValue={singleChalanItemForReturn.cfg_product?.product_name || ''}
                disabled={true}
                type="text"
                placeholder="product name"
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            {/*Current Store*/}
            <Form.Group
              className="mb-2"
              controlId="formBasicEmail"
            >
              <Form.Label>Current Store</Form.Label>
              <Form.Control
                defaultValue={singleChalanItemForReturn.cfg_store?.store_name || ''}
                disabled={true}
                type="text"
                placeholder="Current store"
              />
            </Form.Group>
          </Col>

          <Col md={4}>
            <CommonStoreDropdown
              control={control}
              isRequired={true}
              title="Transfer store"
            />
          </Col>

          <Col md={4}>
            {/*transfer qty*/}
            <Form.Group
              className="mb-2"
              controlId="formBasicEmail"
            >
              <Form.Label>Transfer Qty</Form.Label>
              <span className="text-danger">&nbsp; {singleChalanItemForReturn.purchase_unit?.unit_name && 'in ' + singleChalanItemForReturn.purchase_unit?.unit_name}</span>
              <Form.Control
                autocomplete={'off'}
                type="text"
                placeholder="Transfer qty"
                className={errors.transferred_qty_in_pur_unit ? 'is-invalid' : ''}
                {...register('transferred_qty_in_pur_unit', {
                  required: true,
                  min: 0,
                  pattern: Regex.numeric(),
                  onChange: (event) => {},
                })}
              />
              {/*validation message*/}
              {errors.transferred_qty_in_pur_unit && (
                <span className="text-danger">
                  {errors.transferred_qty_in_pur_unit.type == 'required' && 'This field is required.'}
                  {errors.transferred_qty_in_pur_unit.type == 'pattern' && 'Please provide a valid number'}
                  {errors.transferred_qty_in_pur_unit.type == 'min' && 'Do not enter any negative number.'}
                </span>
              )}
            </Form.Group>
          </Col>

          <Col md={4}>
            {/*transfer bonus  qty*/}
            <Form.Group
              className="mb-2"
              controlId="formBasicEmail"
            >
              <Form.Label>Transfer bonus qty</Form.Label>
              <span className="text-danger">&nbsp; {singleChalanItemForReturn.purchase_unit?.unit_name && 'in ' + singleChalanItemForReturn.purchase_unit?.unit_name}</span>
              <Form.Control
                autocomplete={'off'}
                type="text"
                placeholder="Transfer bonus qty"
                className={errors.transferred_bonus_qty_in_pur_unit ? 'is-invalid' : ''}
                {...register('transferred_bonus_qty_in_pur_unit', {
                  required: true,
                  min: 0,
                  pattern: Regex.numeric(),
                  onChange: (event) => {},
                })}
              />
              {/*validation message*/}
              {errors.transferred_bonus_qty_in_pur_unit && (
                <span className="text-danger">
                  {errors.transferred_bonus_qty_in_pur_unit.type == 'required' && 'This field is required.'}
                  {errors.transferred_bonus_qty_in_pur_unit.type == 'pattern' && 'Please provide a valid number'}
                  {errors.transferred_bonus_qty_in_pur_unit.type == 'min' && 'Do not enter any negative number.'}
                </span>
              )}
            </Form.Group>
          </Col>
        </Row>

        <div className="text-end">
          <Button
            ref={storeTransferBtnRef}
            variant="danger"
            disabled={false}
            className="mt-2 "
            type="submit"
          >
            Transfer
            <ButtonLoader />
          </Button>
        </div>
      </Form>
    </>
  );
}

export default StoreTransferForm;
